export default __webpack_public_path__ + "static/media/notification-bell.66711867.svg";